
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[...destination]",
      function () {
        return require("private-next-pages/sitemap/[...destination]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/[...destination]"])
      });
    }
  